import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "lib/store"

interface DiscountCodeNavigation {
  discountCode: string
  fromDate: string
  toDate: string
}

interface ProductNavigation {
  productId: string
  fromDate: string
  toDate: string
}

interface OrderState {
  orderLoading: boolean
  discountCodeNavigation: DiscountCodeNavigation | null
  productNavigation: ProductNavigation | null
}

const initialStateValue: OrderState = {
  orderLoading: false,
  discountCodeNavigation: null,
  productNavigation: null
}

const slice = createSlice({
  name: "order",
  initialState: initialStateValue,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.orderLoading = action.payload
      document.documentElement.classList.remove("sidebar-open")
    },
    setDiscountCodeNavigation: (state, action: PayloadAction<DiscountCodeNavigation>) => {
      state.discountCodeNavigation = action.payload
    },
    clearDiscountCodeNavigation: (state) => {
      state.discountCodeNavigation = null
    },
    setProductNavigation: (state, action: PayloadAction<ProductNavigation>) => {
      state.productNavigation = action.payload
    },
    clearProductNavigation: (state) => {
      state.productNavigation = null
    }
  }
})

const { actions, reducer } = slice
export const {
  setLoading,
  setDiscountCodeNavigation,
  clearDiscountCodeNavigation,
  setProductNavigation,
  clearProductNavigation
} = actions
export const selectDiscountCodeNavigation = (state: RootState) => state.order.discountCodeNavigation
export const selectProductNavigation = (state: RootState) => state.order.productNavigation

export default reducer
